import { CachedCTAResource } from "./CachedCTAResource";

export class ResourcesCache {
  readonly animationsBySrc = new Map<string, any>();
  readonly ctasByType = new Map<string, CachedCTAResource>();
}
